import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/ui-kit";
import { PageHero } from "@/components/PageHero";
import { NewsletterForm } from "@/components/NewsletterForm";
import { Seo } from "@/components/Seo";
import { IMAGES } from "@/lib/content";

const BENEFITS = [
  "A community of people building on purpose",
  "Monthly Builder conversations & live sessions",
  "Accountability that keeps you moving",
  "Early access to new frameworks and tools",
  "Encouragement grounded in character, not hype",
  "Real relationships with fellow Builders",
];

export default function BuildersCircle() {
  return (
    <div data-testid="builders-circle-page">
      <Seo title="Builders Circle" description="Join a community of people building lives of purpose, character, and lasting impact." path="/builders-circle" />
      <PageHero
        eyebrow="The Community"
        title="Builders Circle"
        subtitle="Building a meaningful life is hard to do alone. Builders Circle is where people who refuse to just survive come together to grow, serve, and build — side by side."
        testId="builders-circle-hero"
      />

      <section className="bg-white text-black py-28 lg:py-36">
        <div className="max-w-[1240px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <Reveal>
            <img src={IMAGES.community} alt="A community of builders" className="w-full h-[500px] object-cover" />
          </Reveal>
          <Reveal delay={120}>
            <Eyebrow className="!text-[#B8952E]">Why It Matters</Eyebrow>
            <h2 className="font-display text-4xl lg:text-5xl mt-6 tracking-tight leading-tight">
              You become who you surround yourself with.
            </h2>
            <ul className="mt-9 space-y-4">
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-start gap-4 font-body text-lg text-black/75">
                  <Check size={20} className="text-[#D4AF37] mt-1 shrink-0" />
                  {b}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      <section className="bg-black noise py-28 lg:py-36">
        <div className="relative z-10 max-w-2xl mx-auto px-6 text-center">
          <Reveal><Eyebrow>Doors Open Soon</Eyebrow></Reveal>
          <Reveal delay={100}>
            <h2 className="font-display text-3xl lg:text-5xl text-white mt-7 leading-tight tracking-tight">
              Be the first to know when the Circle opens.
            </h2>
          </Reveal>
          <Reveal delay={200}>
            <p className="font-body text-white/55 mt-7">
              Join the waitlist and start with the book today — every Builder’s journey begins with The Shift.
            </p>
          </Reveal>
          <Reveal delay={260}>
            <div className="mt-10 flex justify-center">
              <NewsletterForm
                sourcePage="builders-circle-waitlist"
                tags={["Builders Circle"]}
                placeholder="Enter your email to join the waitlist"
                buttonText="Join the Waitlist"
                testId="circle-waitlist"
              />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
